import React, { useEffect } from "react";
import {
  Container,
  Title,
  Paragraph,
  Wrap,
  Card,
  ProductName,
  AddButton,
  ProductImage,
  CardContainer,
  Information,
  Buttons,
  InfoButton,
} from "./PricingPageComponents.jsx";

import { cardAnimation } from "./cardanimation.js";

// We use npm install vanilla-tilt for the animation of 3d
// Maybe adda modal to these card to know more info as well as add to card (which if the user is authenticated, has the card. And if not, goes to login)
function PricingPage() {
  useEffect(() => {
    cardAnimation();
  }, []);
  return (
    <Container id="pricing">
      <Wrap>
        <Title>Pricing</Title>
        <Paragraph>
          Our pricing is <span>modular</span>, which means that is completely
          adapted to your needs.
        </Paragraph>
      </Wrap>

      <CardContainer>
        <Card className="card">
          <ProductName className="productName">Navbar</ProductName>
          <AddButton className="productButton">Add to List</AddButton>
          <InfoButton className="productButton">More info</InfoButton>
          <div></div>
          <ProductImage></ProductImage>
        </Card>
        <Card className="card">
          <ProductName className="productName">Sidebar</ProductName>
          <AddButton className="productButton">Add to List</AddButton>
          <InfoButton className="productButton">More info</InfoButton>{" "}
          <div></div>
          <ProductImage></ProductImage>
        </Card>
        <Card className="card">
          <ProductName className="productName">Web Responsive</ProductName>
          <AddButton className="productButton">Add to List</AddButton>
          <InfoButton className="productButton">More info</InfoButton>{" "}
          <div></div>
          <ProductImage></ProductImage>
        </Card>
        <Card className="card">
          <ProductName className="productName">Mobile First</ProductName>
          <AddButton className="productButton">Add to List</AddButton>
          <InfoButton className="productButton">More info</InfoButton>{" "}
          <div></div>
          <ProductImage></ProductImage>
        </Card>
        <Card className="card">
          <ProductName className="productName">Mobile First</ProductName>
          <AddButton className="productButton">Add to List</AddButton>
          <InfoButton className="productButton">More info</InfoButton>{" "}
          <div></div>
          <ProductImage></ProductImage>
        </Card>
      </CardContainer>
    </Container>
  );
}

export default PricingPage;
